















































































































































































































































































































































































































































import Vue from "vue";
import Confirm from "@/components/atoms/Confirm.vue";
import JustifiedList from "@/components/atoms/JustifiedList.vue";
import DropdownComponent from "@/components/atoms/DropdownComponent.vue";
import DigitChanger from "@/components/atoms/DigitChanger.vue";
import ToggleSwitcher from "@/components/atoms/ToggleSwitcher.vue";
import TextFieldComponent from "@/components/atoms/TextFieldComponent.vue";
import TextAreaComponent from "@/components/atoms/TextAreaComponent.vue";
import DateComponent from "@/components/atoms/DateComponent.vue";
import { dateFormat } from "@/helpers";
import axios from "axios";
import { ApiUrl } from "@/config/ApiUrl";
import { mapState } from "vuex";
import LoadingComponent from "@/components/atoms/LoadingComponent.vue";
import * as Sentry from "@sentry/browser";

interface CreateAgreementRequest {
  amount: number;
  agreementTypeId: number;
  serviceLocationId: number;
  wasteTypeId: number;
  containerTypeId: number | unknown; // unknown only because of crappy computed...
  externalSystemId?: string;
  desiredDate: string;
  ownContainer: boolean;
  hint: string;
  selectedPeriod: string;
  selectedInterval: string;
  selectedFirstDay: string;
  selectedSecondDay: string;
  customerSpecialAgreementId?: string;
  customerSpecialOrderId?: string;
}
enum AgreementType {
  EINMALAUFTRAG = 1,
  SOFORTBEFÜLLUNG = 2,
  DAUERAUFTRAG_AUF_ABRUF = 3,
  DAUERAUFTRAG_IM_TURNUS = 4
}
export default Vue.extend({
  components: {
    Confirm,
    JustifiedList,
    DropdownComponent,
    DigitChanger,
    ToggleSwitcher,
    TextFieldComponent,
    DateComponent,
    TextAreaComponent,
    LoadingComponent,
  },
  props: {
    isEnabled: Boolean,
    isMobile: Boolean,
    schema: Object,
  },
  data: () => {
    return {
      isHinweisValid: true,
      isLoading: false,
      dialog: false, // confirmation dialog
      agreementTypeId: 3,
      wasteType: 0,
      containerType: null,
      containerId: 0,
      containerIdOverride: 0,
      hasLid: false,
      ownContainer: false,
      amount: 1,
      datePickerDesired: false,
      desiredDateFormatted: "",
      desiredDate: "",
      note: "",
      selectedPeriod: "Egal",
      selectedInterval: "Wöchentlich",
      selectedFirstDay: "Egal",
      selectedSecondDay: "Egal",
      periods: ["Egal", "Vormittags", "Nachmittags"],
      intervals: [
        "Wöchentlich",
        "2x pro Woche",
        "14-tägig",
        "4 Wochen",
        "6 Wochen",
        "8 Wochen",
      ],
      days: ["Egal", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag"],
      customerSpecialAgreementId: "",
      customerSpecialOrderId: "",
      agreement: {},
      selectedWasteContainerIds: [] as number[],
      selectedWasteContainers: [] as string[],
    };
  },
  methods: {
    closeMe() {
      this.$emit("close-add-dialog");
    },
    validate() {
      // @todo form validation
      if (
        // ugly because this.$refs.form.validate() is not typescript ready // missing declaration
        // @see https://stackoverflow.com/questions/52109471/typescript-in-vue-property-validate-does-not-exist-on-type-vue-element/52109899
        !(
          this.$refs.form as Vue & {
            validate: () => boolean;
          }
        ).validate()
      ) {
        return false;
      }
      this.dialog = true;
    },
    add() {
      this.isLoading = true;
      this.dialog = false;
      const payload: CreateAgreementRequest = {
        amount: this.amount,
        agreementTypeId: this.agreementTypeId,
        serviceLocationId: this.locationId,
        wasteTypeId: this.wasteType,
        containerTypeId: this.selectedContainerId,
        desiredDate: this.desiredDate,
        ownContainer: this.ownContainer,
        hint: this.note,
        customerSpecialAgreementId: this.customerSpecialAgreementId,
        customerSpecialOrderId: this.customerSpecialOrderId,
        selectedPeriod: this.isImmediateFilling ? this.selectedPeriod : "",
        selectedInterval: this.isRepeatingOnCall ? this.selectedInterval : "",
        selectedFirstDay: this.isRepeatingOnCall ? this.selectedFirstDay : "",
        selectedSecondDay: this.isTwoTimesInterval
          ? this.selectedSecondDay
          : "",
      };
      if(this.company.connectToMynature && !this.company.locationDetail.externalSystemId ) {
        this.$store.dispatch("getLocationDetail", this.company.locationDetail.id).then(res => {
          if(res.data.company.connectToMynature && !res.data.externalSystemId ) {
            this.isLoading = false;
            this.$toast.error("Ups! Konnte keine Vereinbarung erstellen. Bitte versuchen Sie es erneut!", { timeout: 5000 });
            Sentry.captureException(new Error(`Ups! Konnte keine Vereinbarung erstellen. Bitte versuchen Sie es erneut!\n ServiceLocation ID:${res.data.id}`));
          } else {
            axios
              .request({
                method: "post",
                url: ApiUrl.AGREEMENT_CREATE,
                data: payload,
              })
              .then((res) => {
                this.$emit("done-add-successfully");
                this.isLoading = false;

              })
              .catch((err) => {
                if (err.message === "Request failed with status code 400") {
                  this.$toast.error("Diese Vereinbarung besteht bereits");
                }
                Sentry.captureException(err);
                this.$emit("close-add-dialog");
                this.isLoading = false;
              });
          }
        });
      } else {
        axios
          .request({
            method: "post",
            url: ApiUrl.AGREEMENT_CREATE,
            data: payload,
          })
          .then((res) => {
            this.$emit("done-add-successfully");
            this.isLoading = false;

          })
          .catch((err) => {
            if (err.message === "Request failed with status code 400") {
              this.$toast.error("Diese Vereinbarung besteht bereits");
            }
            Sentry.captureException(err);
            this.$emit("close-add-dialog");
            this.isLoading = false;
          });
      }
    },
    checkContainerType: function (containerTypeValue: any) {
      this.containerType = containerTypeValue.trim();
      const selectedContainer = this.schema.containerTypes.filter(
        (container: any) => {
          return (
            container.type.trim() === this.containerType &&
            this.selectedWasteContainerIds.includes(container.id)
          );
        }
      ) as any;
      if (selectedContainer.length === 1 && !selectedContainer[0].size) {
        this.containerIdOverride = selectedContainer[0].id;
      }
    },
    setOrderDate: function (dateValue: string) {
      this.desiredDate = dateValue;
      this.desiredDateFormatted = dateFormat(this.desiredDate);
    },
    allowedDates: (val: any) => new Date(val).getDay() % 6,
    setWasteType: function (wasteTypeValue: any) {
      const selectedWasteType = this.schema.wasteTypes.filter((waste: any) => {
        return waste.id === wasteTypeValue;
      }) as any;
      this.selectedWasteContainerIds = selectedWasteType[0].containers
        .split(",")
        .map(function (containerId: any) {
          return parseInt(containerId, 10);
        });
      const selectedWasteContainers: string[] = [];
      this.schema.containerTypes.forEach((container: any) => {
        if (this.selectedWasteContainerIds.includes(container.id)) {
          if (!selectedWasteContainers.includes(container.type)) {
            selectedWasteContainers.push(container.type);
          }
        }
      });
      this.selectedWasteContainers = Object.assign([], selectedWasteContainers);
      this.wasteType = wasteTypeValue;
    },
    setContainerId: function (containerId: number) {
      this.containerId = containerId;
    },
    setContainerAmount: function (containerAmount: number) {
      this.amount = containerAmount;
    },
    setSpecialAgreementId: function (specialAgreementId: any) {
      this.customerSpecialAgreementId = specialAgreementId;
    },
    setCustomerSpecialOrderId: function (customerSpecialOrderId: any) {
      this.customerSpecialOrderId = customerSpecialOrderId;
    },
    setAgreementTypeId: function (agreementTypeId: any) {
      this.agreementTypeId = agreementTypeId;
    },
    setSelectedInterval: function (selectedInterval: any) {
      this.selectedInterval = selectedInterval;
    },
    setSelectedFirstDay: function (selectedFirstDay: any) {
      this.selectedFirstDay = selectedFirstDay;
    },
    setSelectedSecondDay: function (selectedSecondDay: any) {
      this.selectedSecondDay = selectedSecondDay;
    },
    setSelectedPeriod: function (selectedPeriod: any) {
      this.selectedPeriod = selectedPeriod;
    },
    setNote: function (note: any) {
      this.note = note;
    },
  },
  computed: {
    ...mapState({
      locationId: (state: any) => state.company.locationDetail.id,
      company: (state: any) => state.company,
      hasAgreementNr: (state: any) => state.company.hasAgreementNr,
      hasOrderNr: (state: any) => state.company.hasOrderNr,
    }),
    containerSizes() {
      return this.schema.containerTypes.filter((container: any) => {
        return (
          container.type === this.containerType &&
          this.selectedWasteContainerIds.includes(container.id)
        );
      });
    },
    agreementTypes() {
      if (this.company.premium) {
        return this.schema.agreementTypes.filter((a: any) => {
          return !this.isLoose
            ? this.ownContainer
              ? a.id === AgreementType.DAUERAUFTRAG_IM_TURNUS || a.id === AgreementType.DAUERAUFTRAG_AUF_ABRUF
              : a.id === AgreementType.DAUERAUFTRAG_AUF_ABRUF || a.id === AgreementType.SOFORTBEFÜLLUNG || a.id === AgreementType.DAUERAUFTRAG_IM_TURNUS
            : a.id === AgreementType.DAUERAUFTRAG_AUF_ABRUF;
        });
      } else {
        return this.schema.agreementTypes.filter((a: any) => {
          return !this.isLoose
            ? a.id === AgreementType.DAUERAUFTRAG_AUF_ABRUF || a.id === AgreementType.DAUERAUFTRAG_IM_TURNUS
            : a.id === AgreementType.DAUERAUFTRAG_AUF_ABRUF;
        });
      }
    },
    selectedContainerId(): number {
      return this.containerIdOverride
        ? this.containerIdOverride
        : this.containerId;
    },
    selectedContainer() {
      return this.schema.containerTypes.filter((container: any) => {
        return container.id === this.selectedContainerId;
      })[0];
    },
    selectedWasteType() {
      return this.schema.wasteTypes.filter((waste: any) => {
        return waste.id === this.wasteType;
      })[0];
    },
    showCreateAgreement(): boolean {
      return this.$store.getters.userIsAgreementManager;
    },
    isLoose() {
      return (
        this.containerType === "Lose Abholung" ||
        this.containerType === "Big Bag" ||
        this.containerType === "Sammelsack" ||
        this.containerType === "Foliensack"
      );
    },
    isImmediateFilling() {
      return this.agreementTypeId === 2;
    },
    isRepeatingOnCall() {
      return this.agreementTypeId === 4;
    },
    selectedAgreementType() {
      return this.schema.agreementTypes.filter((a: any) => {
        return a.id === this.agreementTypeId;
      })[0];
    },
    isTwoTimesInterval() {
      return this.selectedInterval === "2x pro Woche";
    },
    wordingWunschtermin() {
      if (this.ownContainer === false && this.agreementTypeId === 2) {
        return "Wunschtermin (Sofortbefüllung)";
      } else if (this.ownContainer === false && this.agreementTypeId === 3) {
        return "Wunschtermin (Stellung)";
      } else if (this.ownContainer === false && this.agreementTypeId === 4) {
        return "Wunschtermin (Stellung)";
      } else if (this.ownContainer === true && this.agreementTypeId === 4) {
        return "Wunschtermin (erste Leerung)";
      } else {
        return "Wunschtermin";
      }
    },
  },
});
